import { Button } from '@fluentui/react-components'

interface LinkActionButtonProps {
  text: string
  url: string
  className?: string
  disabled?: boolean
  newTab?: boolean
}

const LinkActionButton = ({
  text,
  url,
  className,
  disabled,
  newTab = true,
}: LinkActionButtonProps) => {
  const openLink = () => {
    if (disabled || !url) return

    if (newTab) {
      window.open(url, '_blank', 'noreferrer')
      return
    }

    window.location.assign(url)
  }

  return (
    <Button
      size="small"
      appearance="primary"
      className={className}
      onClick={openLink}
      disabled={disabled || !url}
    >
      {text}
    </Button>
  )
}

export default LinkActionButton
